import { User } from 'graphql.generated';
import { parseJSON } from 'date-fns';
import { isWithinOneMinute } from './isWithinOneMinute';

export const isNewUser = (
    sessionUser: Pick<User, 'registered'>,
    registeredUser?: User
) => {
    if (sessionUser.registered === false) {
        return true;
    }

    const today = new Date();
    // set default as sign in user if no creation date
    const regDate = parseJSON(
        registeredUser?.creationDate || '1990-01-01 00:00:00'
    );

    return isWithinOneMinute(today, regDate);
};
